import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// POST that reads an SSE stream and resolves with the final {result} JSON payload.
// Used for long AI JSON endpoints so the socket stays alive past the ingress timeout.
export async function postForJsonSSE(path, body) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (res.status === 401 || res.status === 403) {
    let detail = "Access denied";
    try { detail = (await res.json()).detail || detail; } catch {}
    const err = new Error(detail);
    err.response = { status: res.status, data: { detail } };
    throw err;
  }
  if (!res.ok || !res.body) throw new Error("Request failed");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const payload = JSON.parse(line.slice(5).trim());
      if (payload.error) throw new Error(payload.error);
      if (payload.result) return payload.result;
    }
  }
  throw new Error("The AI response was incomplete — please try again.");
}
